export default {

  /** 新增物料管理 */
  insertYcMaterial: '/ygsjzs/ycMaterial/insertYcMaterial',
  // 修改物料管理
  updateYcMaterial: '/ygsjzs/ycMaterial/updateYcMaterial',

  // 删除物料管理
  deleteYcMaterial: '/ygsjzs/ycMaterial/deleteYcMaterial',
  // 查询物料管理详情
  selectYcMaterialByMaterialId: '/ygsjzs/ycMaterial/selectYcMaterialByMaterialId',
  // 分页查询物料管理列表
  selectYcMaterialByPage: '/ygsjzs/ycMaterial/selectYcMaterialByPage'

}
